import { render, staticRenderFns } from "./AvatarGeneratorView.vue?vue&type=template&id=1415664c&"
import script from "./AvatarGeneratorView.vue?vue&type=script&lang=js&"
export * from "./AvatarGeneratorView.vue?vue&type=script&lang=js&"
import style0 from "./AvatarGeneratorView.vue?vue&type=style&index=0&id=1415664c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports